import React, { useEffect, useRef } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { useQueryTimesheetAdditionalSettings } from '@/lib/api/company/configuration/timesheet-additional/useQueryTimesheetAdditionalSettings'

const TIMESHEET_OPTIONS = [
  {
    label: 'printout.printTimesheetForSettlementPeriod',
    value: 0,
  },
  {
    label: 'printout.printTimesheetForSelectedMonths',
    value: 1,
  },
]

const Timesheet = ({ companyId }: { companyId: string }) => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()
  const { data: timesheetConfiguration } =
    useQueryTimesheetAdditionalSettings(companyId)
  const amountsInitialized = useRef(false)

  useEffect(() => {
    setData({
      timesheetOption: 0,
      period: true,
      printDayNotes: false,
      printDayActivities: false,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [])

  // Domyslny stan "Wydruk wyliczen" bierzemy z ustawien firmy - dopoki nie znamy
  // konfiguracji, pole zostaje nieustawione i o wydruku decyduje serwer.
  useEffect(() => {
    if (!timesheetConfiguration || amountsInitialized.current) return
    amountsInitialized.current = true
    setData((prev: any) => ({
      ...prev,
      amounts: timesheetConfiguration.printTimesheetAmounts ?? false,
    }))
  }, [timesheetConfiguration])

  const timesheetOptions = Object.values(TIMESHEET_OPTIONS).map((ct) => ({
    value: ct.value.toString(),
    label: t(ct.label),
  }))
  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.period')}
            placeholder={t('common.select')}
            value={data?.period === true ? '0' : '1'}
            name="period"
            onChange={(e) => {
              setData({
                ...data,
                period: e.target.value === '0',
              })
            }}
            searchEnabled={false}
            options={timesheetOptions}
          />
          <CheckboxWithLabelField
            field="amounts"
            data={data}
            setData={setData}
            label={t('printout.print-calculations')}
          />
          <CheckboxWithLabelField
            field="showCoveredAmounts"
            data={data}
            setData={setData}
            label={t('printout.show-current-lump-sum-usage')}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default Timesheet
